import React from 'react';
import { RichTextField, Tab, FormTab, useResourceContext,TextField } from 'react-admin';
import { RichTextInput } from '../../../lib/wrappers/Inputs';
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
import { Typography,Box, Divider,Chip } from '@mui/material';
var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

export const EducationalAimsInputsTab = (source) => {
    const resource = useResourceContext();
    return <FormTab label="Educational Aims" {...source}>
            <Box display="flex">
                <Box flex={1} sx={{ paddingBottom: '20px' }}>
                    <Typography variant="h6" style={titleStyle}>
                        Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
                    </Typography>
                </Box>
            </Box>
            <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Educational Aims" /></b></Divider>
            </Box>
        </Box>
                    <RichTextInput source="educationalAims" label={false} fullWidth />
           
            <VersioningTypeInput source="versioningType" resource={resource} />
        </FormTab>

};

export const EducationalAimsShowTab = (source) => (
    <Tab label="Educational Aims" {...source}>
        <RichTextField source="educationalAims" />
    </Tab>
);
